import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PMJobRunSupportLevel } from 'src/app/modules/platform/monitoring/models/pm-job-run-support-level';
import {
    ALL_SUPPORT_LEVEL_OPTION_VM,
    SUPPORT_LEVEL_OPTION_VMS,
    SupportLevelOptionVM
} from '../../constants/support-levels';
import { HcPopComponent } from '@healthcatalyst/cashmere';

@Component({
    selector: 'cdp-job-run-support-level-selector',
    templateUrl: './job-run-support-level-selector.component.html',
    styleUrls: ['./job-run-support-level-selector.component.scss'],
    standalone: false
})
export class JobRunSupportLevelSelectorComponent {
    @Input() selectedSupportLevel = ALL_SUPPORT_LEVEL_OPTION_VM.supportLevel;
    @Output() supportLevelSelected = new EventEmitter<PMJobRunSupportLevel>();
    @ViewChild(HcPopComponent) supportLevelOptionsPop: HcPopComponent;
    public get selectedSupportLevelOption(): SupportLevelOptionVM {
        return (
            this.supportLevelOptions.find(o => o.supportLevel === this.selectedSupportLevel) ??
            ALL_SUPPORT_LEVEL_OPTION_VM
        );
    }
    public readonly supportLevelOptions = SUPPORT_LEVEL_OPTION_VMS;

    selectSupportLevel(supportLevel: PMJobRunSupportLevel): void {
        this.selectedSupportLevel = supportLevel;
        this.supportLevelSelected.emit(this.selectedSupportLevel);
        this.supportLevelOptionsPop.close();
    }
}
